import { createApp } from 'vue'
import "vue-multiselect/dist/vue-multiselect.css"
import "./apps/public/assets/scss/style.scss";
import App from './apps/public/App.vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import 'v-calendar/dist/style.css';
import router from './apps/public/router'
import {helper} from "@/service/CommonHelper";
import store from './store'
import axios from "axios";
import VueAxios from 'vue-axios'
import Notifications from '@kyvg/vue3-notification'
import { vMaska } from "maska"
import VueQrcode from '@chenfengyuan/vue-qrcode';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

helper.setLang(store.getters.lang)
helper.setPhoneCodes(require('@/assets/phonecodes.json'))
window.API_URL = process.env.VUE_APP_API_URL as string
axios.defaults.baseURL = window.API_URL;
axios.defaults.headers.common = {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-GA-ID': process.env.VUE_APP_X_GA_REF as string
}

const fpPromise = FingerprintJS.load().then(fp => fp.get()).then(result => {
    axios.defaults.headers.common['X-Fingerprint'] = result.visitorId
})

axios.interceptors.request.use(async (config) => {
    await fpPromise
    return config
})


router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            if (to.meta.roles.indexOf(store.getters.getRole) === -1) {
                next('/login');
                return;
            }

            next();
            return;
        }
        next('/login');
    } else {
        next();
    }
});

const app = createApp(App)

app.config.globalProperties.$t = (key: string, params: any = {}, fallback: string|null = null) => {
    return helper.trans(key, params, fallback)
}
app
    .directive("maska", vMaska)
    .use(VueAxios, axios)
    .use(Notifications)
    .use(BootstrapVue3)
    .use(store)
    .use(router)
    .component(VueQrcode.name, VueQrcode)
    .mount('#app')
